/**
 * Fuerza `metodo_pago` en BD a 'CREDITO' si el texto es crédito en cualquier capitalización/acento.
 * No altera EFECTIVO, NEQUI, etc.
 */
export function normalizeMetodoPagoDbValue(value: string | null | undefined): string | null {
  if (value == null) return null;
  const t = String(value).trim();
  if (t === '') return null;
  const fold = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  if (fold === 'credito') return 'CREDITO';
  return t;
}
